import { atom } from "jotai";

export interface FileEntityState {
  loading: boolean;
  data: any[] | null;
  lastFetched: number | null;
}

export const fileEntitiesAtom = atom<FileEntityState>({
  loading: false,
  data: [],
  lastFetched: null,
});
